import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserAttempts, startTest } from '../services/api';

export interface Attempt {
  id: number;
  language: string;
  status: string;
  started_at: string;
  completed_at: string | null;
  raw_score: number | null;
  profile_type: string | null;
}

export const useDashboard = () => {
  const [attempts, setAttempts] = useState<Attempt[]>([]);
  const [remainingAttempts, setRemainingAttempts] = useState(0);
  const [loading, setLoading] = useState(true);
  const [starting, setStarting] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const navigate = useNavigate();

  const userId = localStorage.getItem('userId');

  const loadAttempts = useCallback(async () => {
    if (!userId) return;
    try {
      const response = await getUserAttempts(Number(userId));
      setAttempts(response.data.attempts || []);
      setRemainingAttempts(response.data.remaining_attempts ?? 0);
    } catch (err) {
      console.error('Failed to load attempts:', err);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) { navigate('/'); return; }
    loadAttempts();
  }, [userId, loadAttempts, navigate]);

  const handleStartTest = useCallback(async (
    language: 'french' | 'arabic' | 'english'
  ) => {
    setStarting(true);
    try {
      const response = await startTest({
        user_id: Number(userId),
        language,
        test_version: 'A',
      });
      localStorage.setItem('sessionId', response.data.session_id.toString());
      localStorage.setItem('attemptId', response.data.attempt_id.toString());
      navigate('/test');
    } catch (err: any) {
      alert(err.response?.data?.detail || 'Échec du démarrage');
      setStarting(false);
    }
  }, [userId, navigate]);

  const handleLogout = useCallback(() => {
    localStorage.clear();
    navigate('/');
  }, [navigate]);

  return {
    attempts,
    remainingAttempts,
    loading,
    starting,
    showInstructions,
    setShowInstructions,
    handleStartTest,
    handleLogout,
  };
};
